import { EntityRoutes } from 'routes/constants';

import { JobOrderQueryActions } from '../JobOrderProfile/utils';

export const navigateToSendout = history => (event, options) => {
  const { sendoutId, placementId, sendout } = options || {};
  let queryParam = '';
  if (sendoutId) queryParam = `form=${JobOrderQueryActions.PlacementCreation}&id=${sendoutId}`;

  if (placementId) queryParam = `form=${JobOrderQueryActions.PlacementDetail}&id=${placementId}`;

  const queryPath = `tab=${JobOrderQueryActions.PlacementTab}&${queryParam}`;
  const JOEndpoint = EntityRoutes.JobOrderProfile.replace(':id', sendout?.joborder?.id);
  history.push(`${JOEndpoint}?${queryPath}`);
};

const SENDOUT_STATUS_REASON_TRIGGER_IDS = {
  noOffer: [3, 6],
  declined: [4, 7]
};

const buildSendoutStatusReasonOptions = ({ statusTitle, reasons, initialId }) =>
  reasons.map((reason, index) => ({
    id: initialId + index,
    title: reason,
    value: reason,
    status: { title: statusTitle }
  }));

// TODO: replace with actual reasons from the backend once available
export const SENDOUT_STATUS_REASON_OPTIONS = {
  noOffer: buildSendoutStatusReasonOptions({
    statusTitle: 'No Offer',
    reasons: [
      'Accepted another position (not through us)',
      'Accepted another position (through us)',
      'Candidate skillset does not match',
      'Company filled position (not through us)',
      'Company filled position (through us)',
      'Culture and personality does not match',
      'Salary expectation too high'
    ],
    initialId: 10
  }),
  declined: buildSendoutStatusReasonOptions({
    statusTitle: 'Declined',
    reasons: [
      'Accepted another position (not through us)',
      'Accepted another position (through us)',
      'Company filled position (through us)',
      'Counteroffer',
      'Doesn’t want to make a change anymore',
      'Not a good fit',
      'Offer was too low',
      'Other Reason'
    ],
    initialId: 20
  })
};

const getSelectedSendoutStatusIds = filters =>
  Array.isArray(filters?.sendoutStatuses) ? filters.sendoutStatuses.map(status => status.id) : [];

export const shouldShowSendoutStatusReasons = filters => {
  const selectedIds = getSelectedSendoutStatusIds(filters);

  return [
    ...SENDOUT_STATUS_REASON_TRIGGER_IDS.noOffer,
    ...SENDOUT_STATUS_REASON_TRIGGER_IDS.declined
  ].some(id => selectedIds.includes(id));
};
